import React from 'react'

const Footer = () => (
  <footer className="py-6 border-t mt-12 border-gray-200">
    <p>Copyright © 2021 Teyvat Guide. All Rights Reserved</p>
    <p>
      teyvatguide.com is not affiliated wtih miHoYo. Genshin impact, game content and materials are trademarks and
      copyrights of miHoYo
    </p>
  </footer>
)

export default Footer
